import './styles/App.css';
import './styles/Variables.css'; 
import './styles/ResolutionControl.css';
import './styles/FormElements.css';
import './styles/Navigation.css';
import './styles/Fonts.css';
import './styles/NotificationDropdown.css';
import './styles/CopilotElements.css';
import './styles/Cards.css';
import './styles/Buttons.css';
import './styles/GenBIStudio.css';
import './styles/GenBICanvas.css';
import './styles/Slr.css';
import './styles/DashboardView.css';
import './styles/CustomElements.css';
import './styles/Airspace.css';
import './styles/AskSaraElements.css';

import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';



// IAM auth components
import Login from './components/iamConsole/iamAuth/Login.jsx';
import ConfirmNewPassword from './components/iamConsole/iamAuth/ConfirmNewPassword.jsx';
import ForgotPassword from './components/iamConsole/iamAuth/ForgotPassword.jsx';
import ResetPassword from './components/iamConsole/iamAuth/ResetPassword.jsx';
import AuthorizedRoute from './components/iamConsole/iamAuth/AuthorizedRoute.jsx';
import AuthorizedLoginRoute from './components/iamConsole/iamAuth/AuthorizedLoginRoute.jsx';

// IAM Components
import UnstructuredThreadManagement from './components/iamConsole/threads/UnstructuredThreadManagement.jsx';
import TeamManagement from './components/iamConsole/teams/TeamManagement.jsx';
import DataFabricManagement from './components/iamConsole/dataFabrics/DataFabricManagement.jsx';

import ScreeningSpaceHome from './components/iamConsole/slrTools/screeningSpace/ScreeningSpaceHome.jsx'; 
import Copilot from './components/iamConsole/copilotComponents/Copilot.jsx';
import TextractorDashboard from './components/iamConsole/textractor/TextractorManagement.jsx'; 
import GenbiDashboard from './components/iamConsole/genbi/GenbiDashboard.jsx'; 
import LiteratureDiscovery from './components/iamConsole/slrTools/literatureDiscovery/LiteratureDiscovery.jsx';
import ScreeningSpace from './components/iamConsole/slrTools/screeningSpace/ScreeningSpaceHome.jsx';
import GenAIRights from './components/iamConsole/slrTools/genai_rights/GenAIRights.jsx';

// Admin components
import AdminAuthorizedRoute from './components/administration/administrationAuth/AdminAuthorizedRoute.jsx';
import AdminAuthorizedLoginRoute from './components/administration/administrationAuth/AdminAuthorizedLoginRoute.jsx';
import AdminLogin from './components/administration/administrationAuth/AdminLogin.jsx';
import AdminConfirmNewPassword from './components/administration/administrationAuth/AdminConfirmNewPassword.jsx';
import AdminForgotPassword from './components/administration/administrationAuth/AdminForgotPassword.jsx';
import AdminResetPassword from './components/administration/administrationAuth/AdminResetPassword.jsx';
import AdminDashboard from './components/administration/administrarionServices/AdminDashboard.jsx';
import AdminPermissionSetManagement from './components/administration/administrarionServices/AdminPermissionSetManagement.jsx';
import AdminIamUserManagement from './components/administration/administrarionServices/AdminIAMUserManagement.jsx';

//Global
import Home from './components/globalComponents/homepage/Home.jsx';
import UserGuide from './components/globalComponents/UserGuide.jsx';


 

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin-login" element={<AdminAuthorizedLoginRoute element={AdminLogin}/>} />
        <Route path="/admin-confirm-new-password" element={<AdminConfirmNewPassword />} /> 
        <Route path="/admin-forgot-password" element={<AdminForgotPassword />} />
        <Route path="/admin-reset-password" element={<AdminResetPassword />} />

        <Route path="/admindashboard" element={<AdminAuthorizedRoute element={AdminDashboard}/>} />
        <Route path="/admin-manage-permission-sets" element={<AdminAuthorizedRoute element={AdminPermissionSetManagement}/>} />
        <Route path="/admin-manage-iam-users" element={<AdminAuthorizedRoute element={AdminIamUserManagement}/>} />
        <Route 
          path="/admin-user-guide" 
          element={<AdminAuthorizedRoute element={() => <UserGuide consoleType="admin-console" />} />} 
        />


        <Route path="/login" element={<AuthorizedLoginRoute element={Login}/>} />
        <Route path="/confirm-new-password" element={<ConfirmNewPassword />} /> 
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/dashboard" element={<Navigate to="/screening-space" replace />} />  {/* Dashboard removed: Screening Space is the entry point */}  
        <Route path="/unstructured-threads" element={<AuthorizedRoute element={UnstructuredThreadManagement} />} /> 

        <Route path="/teams" element={<AuthorizedRoute element={TeamManagement} />} /> 
        {/* <Route path="/create-slr-fabric" element={<AuthorizedRoute element={SLRManagement} />} />  */}
        <Route path="/slr-ai-studio" element={<AuthorizedRoute element={ScreeningSpaceHome} />} />
        <Route path="/genie.ai" element={<AuthorizedRoute element={Copilot} />} /> 
        <Route path="/textractor" element={<AuthorizedRoute element={TextractorDashboard} />} /> 
        <Route path="/genbi" element={<AuthorizedRoute element={GenbiDashboard} />} /> 


        <Route path="/literature-discovery" element={<AuthorizedRoute element={LiteratureDiscovery} />} /> 
        <Route path="/screening-space" element={<AuthorizedRoute element={ScreeningSpace} />} />
        <Route path="/genai-rights" element={<AuthorizedRoute element={GenAIRights} />} />

         <Route 
          path="/iam-user-guide" 
          element={<AuthorizedRoute element={() => <UserGuide consoleType="iam-console" />} />} 
        />
        {/* Add other routes as needed */}
      </Routes>
    </Router>
  );
};

export default App;